import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Filter, Ruler, Tag, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const features = [{
  icon: Filter,
  title: 'Height-Based Filtering',
  description: 'See only brands and cuts that are specifically engineered for your vertical proportions.'
}, {
  icon: Ruler,
  title: 'Proportion Rules',
  description: 'We analyze rise, inseam, and sleeve length ratios to ensure they match your frame.'
}, {
  icon: Tag,
  title: 'Brand Matching',
  description: "We've identified the specific brands that run short-friendly, so you don't have to guess."
}, {
  icon: Heart,
  title: 'Confidence',
  description: 'Shop knowing it will fit before you buy. No more ordering two sizes and returning both.'
}];
export function SolutionSection() {
  const navigate = useNavigate();
  return <section className="py-24 bg-white" data-id="element-125">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-127">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-text-primary mb-6" data-id="element-128">
            We Match Clothes to Your Height, <br data-id="element-129" />
            <span className="text-accent italic" data-id="element-130">Not Just Your Size</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-text-muted" data-id="element-131">
            Our system filters brands and cuts by proportion—so everything fits
            your frame.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-132">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-primary p-8 rounded-xl border border-transparent hover:border-accent/20 transition-colors duration-300" data-id="element-133">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm text-accent" data-id="element-134">
                <feature.icon className="w-6 h-6" data-id="element-135" />
              </div>
              <h3 className="text-xl font-bold text-text-primary mb-3 font-serif" data-id="element-136">
                {feature.title}
              </h3>
              <p className="text-text-muted leading-relaxed" data-id="element-137">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-138">
          <Button size="lg" onClick={() => navigate('/try-it')} data-id="element-139">
            Get My Perfect Fit
          </Button>
        </div>
      </div>
    </section>;
}